import { css, StyleSheet } from 'aphrodite';
import { useEffect, useState } from 'react';
import { grayIconFill } from '../../../styles/colors';
import { THEME } from '../../Theme/theme';

/**
 * A thinking indicator that displays elapsed time with animated dots.
 * Used in AI Assistant chat to show that a response is being generated.
 *
 * @example
 * ```tsx
 * <ThinkingIndicator />
 * // Renders: "Levitating (2s)..." with animated dots
 * ```
 */
export function ThinkingIndicator() {
	const [elapsedSeconds, setElapsedSeconds] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setElapsedSeconds(s => s + 1);
		}, 1000);
		return () => clearInterval(interval);
	}, []);

	return (
		<span className={css(styles.container)}>
			Levitating ({elapsedSeconds}s)
			<span className={css(styles.dots)}>
				<span className={css(styles.dot, styles.dot1)}>.</span>
				<span className={css(styles.dot, styles.dot2)}>.</span>
				<span className={css(styles.dot, styles.dot3)}>.</span>
			</span>
		</span>
	);
}

const dotAnimation = {
	'0%, 20%': {
		opacity: 0,
	},
	'40%': {
		opacity: 1,
	},
	'100%': {
		opacity: 1,
	},
};

const styles = StyleSheet.create({
	container: {
		color: grayIconFill,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.standard,
	},
	dots: {
		display: 'inline-block',
		width: 16,
		marginLeft: 2,
	},
	dot: {
		animationName: [dotAnimation],
		animationDuration: '1.4s',
		animationIterationCount: 'infinite',
		animationFillMode: 'both',
	},
	dot1: {
		animationDelay: '0s',
	},
	dot2: {
		animationDelay: '0.2s',
	},
	dot3: {
		animationDelay: '0.4s',
	},
});
